@if (mainConfig && innerConfig && innerConfigDataMethod) {
    <div>
        <expandable-list
            [config]="mainConfig"
            [innerConfig]="innerConfig"
            [innerConfigDataMethod]="innerConfigDataMethod"
            [colSpan]="10"
        ></expandable-list>
    </div>
}
